/*
 | Admin spoofing query params (CLUB-899 / F14).
 | Club+ BE (VerifyAuth) reads `spoof_email` or `spoof_email_hash`; email wins when both are
 | set. Sent on every method on purpose: the backend refuses non-GET requests while spoofing
 | with a 403, which is safer than a write silently landing on the admin's own account.
 */
export const spoofQueryParams = (spoofEmail, spoofEmailHash) => {
  if (spoofEmail) {
    return { spoof_email: spoofEmail }
  }
  if (spoofEmailHash) {
    return { spoof_email_hash: spoofEmailHash }
  }
  return {}
}
